/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Sector from 'astro/server/sector';

import * as Influence from 'astro/util/influence';


export default class extends Sector
{
  constructor (cass, planet)
  {
    super(cass, planet);
  }


  install ()
  {
    // no-op.
  }


  isPlatform ()
  {
    return false;
  }


};
